export default __webpack_public_path__ + "media/images/rear-view-11f45334885be18def764d69a0fad825.png";